import { render, staticRenderFns } from "./PublicComponentInfo.vue?vue&type=template&id=6e4602a2&scoped=true"
import script from "./PublicComponentInfo.vue?vue&type=script&lang=js"
export * from "./PublicComponentInfo.vue?vue&type=script&lang=js"
import style0 from "./PublicComponentInfo.vue?vue&type=style&index=0&id=6e4602a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4602a2",
  null
  
)

export default component.exports